import { render, staticRenderFns } from "./register.vue?vue&type=template&id=12aea5ca&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=12aea5ca&prod&scoped=true&lang=css&"
import style1 from "./register.vue?vue&type=style&index=1&id=12aea5ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aea5ca",
  null
  
)

export default component.exports